import {
    forwardRef,
    useImperativeHandle,
    useContext,
    useRef,
} from 'react'

import ApplicantDataFormContext from "../../../../Contexts/ApplicantDataFormContext"
import LocationOfResidenceInput from '../../../../Components/LocationOfResidenceInput'
import TextInput from '../../../../Components/TextInput'

// Name validator
const nameValidator = (val) => /^[\p{L} '-]{2,50}$/u.test(val.trim());

const LocationOfResidence = forwardRef(({ data, locationOfResidenceHandler }, ref) => {

    const locationOfResidenceRef = useRef()

    const applicantDataForm = useContext(ApplicantDataFormContext)

    const fullNameRef = useRef()

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {

            const fullNameResult = fullNameRef.current.validateAndGetData()
            const locationOfResidenceResult = locationOfResidenceRef.current.validateAndGetData()

            const isValid = fullNameResult.isValid && locationOfResidenceResult.isValid

            const value = {
                result: true,
                locationOfResidence: locationOfResidenceResult.value,
                fullName: fullNameResult.value,
            }

            applicantDataForm.current["locationOfResidence"] = value.locationOfResidence
            applicantDataForm.current["fullName"] = value.fullName
            locationOfResidenceHandler(value.locationOfResidence)

            return {
                isValid,
                value,
            }
        },
    }))

    return (
        <div className="flex flex-col items-center justify-center h-full px-6 text-center">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                Your Location of Residence
            </h1>
            <p className="text-gray-700 max-w-md mb-4">
                To provide you with the correct background check forms and legal notices, please tell us where you currently reside.
            </p>

            <div className="w-full max-w-xs text-left mt-6 mb-6">

                <TextInput
                    title="Full Legal Name"
                    description="Provide full legal name, including middle name"
                    ref={fullNameRef}
                    data={data?.fullName}
                    validator={nameValidator}
                    isMandatory={true}
                />

                <label
                    className="block text-lg font-semibold text-gray-800 mb-2"
                >
                    Current Residence
                </label>

                <LocationOfResidenceInput data={data?.locationOfResidence} ref={locationOfResidenceRef} />

            </div>
        </div >
    )

})

export default LocationOfResidence
